import { createStore } from 'satcheljs';
export default createStore('keyboardShortcutsOption', {
    shortcuts: null,
});
//# sourceMappingURL=store.js.map